/**
 * Мапперы ответов лицевого счёта. Отдельным файлом, потому что одна и
 * та же строка журнала приходит и списком, и ответом на создание
 * ручной операции — разбор должен быть один.
 */

import type {LedgerEntry, LedgerKind} from './types';

type Raw = Record<string, unknown>;

export const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
export const asNum = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
export const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');
export const asNullStr = (v: unknown): string | null => (typeof v === 'string' && v ? v : null);

/** Незнакомый kind считаем расходом: ошибиться в минус безопаснее. */
const asKind = (v: unknown): LedgerKind => (v === 'credit' ? 'credit' : 'debit');

export const toLedgerEntry = (raw: unknown): LedgerEntry => {
  const r = asObj(raw);
  return {
    id: asStr(r.id),
    kind: asKind(r.kind),
    source: asStr(r.source),
    amountTiyin: asNum(r.amountTiyin),
    balanceAfterTiyin: asNum(r.balanceAfterTiyin),
    description: asStr(r.description),
    paymentId: asNullStr(r.paymentId),
    periodStart: asNullStr(r.periodStart),
    periodEnd: asNullStr(r.periodEnd),
    createdAt: asStr(r.createdAt),
  };
};
